import React, { useRef } from 'react';
import styled from 'styled-components';
import { SearchUserCard } from './UserCards';
import VipIcon from '../Icons/VipIcons';

const CardWrapper = styled.div`
  background: ${({ theme }) => theme.colors.bg2};
  border-radius: 20px;
  padding: 16px 0;
  margin: 0 auto 20px;
  width: calc(100% - 24px);
  max-width: 500px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 8px 32px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    border-radius: 16px;
    margin-bottom: 16px;
  }

  /* Hide when the desktop right rail is showing (>=1200px) */
  @media (min-width: 1200px) {
    display: none;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 12px;
`;

const Title = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
`;

const CarouselContainer = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 0 16px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
`;

const CardSlot = styled.div`
  flex-shrink: 0;
  width: 200px;
`;

// Controlled: the feed decides whether to show this card (see useSuggestedCreators), so it is never
// an empty list item.
const SuggestedCreatorsCard = ({ creators, onDismiss }) => {
  const carouselRef = useRef(null);

  if (!creators || creators.length === 0) {
    return null;
  }

  return (
    <CardWrapper>
      <Header>
        <Title>Creators you might like</Title>
        <VipIcon name="CloseXCircle" size={18} onClick={onDismiss} />
      </Header>
      <CarouselContainer ref={carouselRef}>
        {creators.map(creator => (
          <CardSlot key={creator.id}>
            <SearchUserCard
              user={creator}
              showStats={false}
              showActions={true}
              avatarSize="44px"
            />
          </CardSlot>
        ))}
      </CarouselContainer>
    </CardWrapper>
  );
};

export default SuggestedCreatorsCard;
